import { Component, OnInit } from '@angular/core';
import { UserManagementService } from '../service/user-management.service'
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'admin-logs',
  templateUrl: './admin-logs.component.html',
  styleUrls: ['./admin-logs.component.css']
})
export class AdminLogsComponent implements OnInit {

  msgs: any[] = [];

  constructor(private dataService: UserManagementService, private router: Router) { }
  ngOnInit() {


    
  }

  downloadLogFile() {
    try {
      //this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
      var fileName = 'Today.log';
      this.dataService.downloadLogFile().subscribe((result: any) => {
        window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(result, fileName);
        }
        let url = window.URL.createObjectURL(result)
        let link = document.createElement('a');
        link.href = url;
        link.download = `${fileName}`;
        link.click();
        setTimeout(() => {
          this.showMessage('success', '', 'הקובץ הופק בהצלחה');
        }, 1000);
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בהורדת הקובץ');
      });
    } catch (error) {
      this.showMessage('error', '', 'תקלה בהורדת הקובץ');
    }
  }

  downloadYesterdayLogFile() {
    try {
      //this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
      var fileName = 'Yesterday.log';
      this.dataService.downloadYesterdayLogFile().subscribe((result: any) => {
        window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(result, fileName);
        }
        let url = window.URL.createObjectURL(result)
        let link = document.createElement('a');
        link.href = url;
        link.download = `${fileName}`;
        link.click();
        setTimeout(() => {
          this.showMessage('success', '', 'הקובץ הופק בהצלחה');
        }, 1000);
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בהורדת הקובץ');
      });
    } catch (error) {
      this.showMessage('error', '', 'תקלה בהורדת הקובץ');
    }
  }

  downloadLastFeedbackLogFile() {
    try {
      //this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
      var fileName = 'LastFeedback.log';
      this.dataService.downloadLastFeedbackLogFile().subscribe((result: any) => {
        window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(result, fileName);
        }
        let url = window.URL.createObjectURL(result)
        let link = document.createElement('a');
        link.href = url;
        link.download = `${fileName}`;
        link.click();
        setTimeout(() => {
          this.showMessage('success', '', 'הקובץ הופק בהצלחה');
        }, 1000);
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בהורדת הקובץ');
      });
    } catch (error) {
      this.showMessage('error', '', 'תקלה בהורדת הקובץ');
    }
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/admin-logs/admin-logs.component.ts